import gql from 'graphql-tag';
import { UrlAliasAllData } from '../fragments';

export default gql`
mutation updateUrlAlias (
    $id: ID!
    $source_url: String!
    $target_url: String!
) {
    updateUrlAlias (input: {
        id: $id,
        source_url: $source_url,
        target_url: $target_url
    }) {
        ...UrlAliasAllData
    }
}
${UrlAliasAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/updateUrlAlias.ts